import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useWizardStepContext from 'v2/components/WizardModal/useWizardStepContext';
import useTenantLegalDocuments from 'v2/hooks/onboarding/useTenantLegalDocuments/useTenantLegalDocuments';
import Rules from './Rules';

const STEP_INDEX = 0;

const AcceptLegalDocumentsSLAStep: React.FC<React.PropsWithChildren> = () => {
  const { goToNext } = useWizardStepContext();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { tenantLegalDocuments, tenantLegalDocumentsLoading } = useTenantLegalDocuments({
    handleFetchError
  });
  const { setFooterContent, steps } = useWizardStepContext();

  const [isSLACheckBoxSelected, setIsSLACheckBoxSelected] = useState(false);

  const handleSLACheckBoxClick = () => {
    setIsSLACheckBoxSelected(!isSLACheckBoxSelected);
  };

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          gap: 2
        }}
      >
        <Button
          key="device-group-name-step-submit"
          id="accept-sla-button"
          variant="contained"
          type="submit"
          disabled={!isSLACheckBoxSelected}
          loading={tenantLegalDocumentsLoading}
          onClick={() => goToNext()}
        >
          Accept SLA
        </Button>
      </Box>
    );
  }, [tenantLegalDocumentsLoading, setFooterContent, steps, isSLACheckBoxSelected]);

  return (
    <Rules
      title="ATLAS Access – Software License Agreement"
      rulesContent={tenantLegalDocuments?.sla.currentText ?? ''}
      rulesName="Software License Agreement (SLA)"
      isCheckBoxChecked={isSLACheckBoxSelected}
      handleCheckBoxOnClick={handleSLACheckBoxClick}
      isLoading={!tenantLegalDocuments}
      checkboxId="accept-sla-checkbox"
    />
  );
};

export default AcceptLegalDocumentsSLAStep;
